import axios from 'axios'
import config from '../config/app'
const PATH = 'hives'
const VERSION = '/v2/'

const hivesAPI = {
  newSendInvites (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + PATH + '/send-invite', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  newGetInvitedByUserId (userId, additional, params) {
    // Get Hive Partner Data By Partner Id
    params = typeof params === 'object' && params !== null ? params : {}
    params.user_id = userId
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  // ==============================================================
  check (code) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/hive/check/' + code).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/' + id, data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives', data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  addMembers (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/addMembers/' + id, data).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  createNewRefCode (data) {
    // Create  New Ref Code
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/create-new-code', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHiveData (id) {
    // Get HIve Partner Data
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/hives/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHiveWithoutLoginData (id) {
    // Get HIve Partner Data
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/guest/hives/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateHiveMember (id, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/updateHiveMember', {
        id: id,
        start_date: data.hive_membership_start_date,
        end_date: data.hive_membership_end_date
      }).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeHiveMember (id) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/removeHiveMember', {id: id}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteHiveMember (id) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/deleteHiveMember', {id: id}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendInvite (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/hives/send-invite', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getInvitedByUserId (type, userId, additional, params) {
    // Get HIve Partner Data By Partner Id
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/hives/get-details/' + userId + '/' + type + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additionalFields) {
    return new Promise((resolve, reject) => {
      this.get({id: id}, additionalFields).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getAll (additionalFields) {
    return this.get({}, additionalFields)
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/hives?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMemberImpacts (userId, params = {}) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + '/hives/member/impact/count?user_id=' + userId + '&' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMemberTopGoals (userId) {
    let url = config.server + '/hives/member/goal/count?user_id=' + userId
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHiveMembers (userId, params = {}) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + '/hives/members?user_id=' + userId + '&' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCurrentHivePartnerData (code) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/app/total-hive-impact/' + code).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMyHive (pageURL, userId = null) {
    let url = config.server + '/hives/page/' + pageURL + '/' + userId
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getMyHiveData (pageURL, userId = null) {
    let url = config.server + '/hives/details/' + pageURL + '/' + userId
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHiveImpacts (pageURL) {
    let url = config.server + '/hives/total-impacts/' + pageURL
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getRecentImpacts (pageURL) {
    let url = config.server + '/hives/recent-impacts/' + pageURL
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getHiveGoals (pageURL) {
    let url = config.server + '/hives/goals/' + pageURL
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default hivesAPI



// WEBPACK FOOTER //
// ./src/api/hives.js